import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

// prettier-ignore
export const SUPPORTED_LANGUAGES = [
  'en', 'ro', 'es', 'bg', 'hr', 'cs', 'da', 'nl', 'et', 'fi', 'fr', 'de',
  'el', 'hu', 'ga', 'it', 'lv', 'lt', 'mt', 'pl', 'pt', 'sk', 'sl', 'sv',
] as const
export const FALLBACK_LANGUAGE = 'en'

/**
 * Translations live in public/locales/{lng}/{ns}.json and are fetched on
 * demand: they never bloat the JS bundle, and a namespace only loads when a
 * feature that uses it renders (via useTranslation('<ns>'), which suspends
 * until it's ready).
 */
void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    load: 'languageOnly',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      // React already escapes rendered strings.
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'app.language',
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  })

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})

export default i18n
